document.addEventListener('DOMContentLoaded', () => {

  const pdpUgcStoriesWrapperNode = document.querySelector('.pdp-ugc-stories__embla');
  const pdpUgcStoriesViewportNode = pdpUgcStoriesWrapperNode.querySelector('.pdp-ugc-stories__viewport');
  const pdpUgcStoriesContainerNode = pdpUgcStoriesWrapperNode.querySelector('.pdp-ugc-stories__container');
  const pdpUgcStoriesEmblaApi = EmblaCarousel(pdpUgcStoriesViewportNode, {
    loop: false,
  });

  const pdpUgcStoriesPrevBtn = document.querySelector('.pdp-ugc-stories__button--prev');
  const pdpUgcStoriesNextBtn = document.querySelector('.pdp-ugc-stories__button--next');

  pdpUgcStoriesPrevBtn?.addEventListener('click', () => {
    pdpUgcStoriesEmblaApi.scrollPrev();
    // 'select' event will handle reset + play
  });

  pdpUgcStoriesNextBtn?.addEventListener('click', () => {
    pdpUgcStoriesEmblaApi.scrollNext();
    // 'select' event will handle reset + play
  });

  const pdpUgcStoriesSlideButtons = document.querySelectorAll('.pdp-ugc-content__video-story-button');

  function updateProgress() {
    const currentIndex = pdpUgcStoriesEmblaApi.selectedScrollSnap();
    const storyBars = document.querySelectorAll('.pdp-ugc-stories .story-bar');

    if (storyBars.length > 0) {
      storyBars.forEach((storyBar) => {
        storyBar.style.setProperty('--story-progress', `0%`);
      });
      for (let i = 0; i < currentIndex; i++) {
        storyBars[i].style.setProperty('--story-progress', `100%`);
      }

      const currentBar = storyBars[currentIndex];
      const video = pdpUgcStoriesContainerNode.querySelector(`.pdp-ugc-stories__slide[data-slide-index="${currentIndex}"] video`);

      if (video && video.duration && currentBar) {
        const progress = (video.currentTime / video.duration) * 100;
        currentBar.style.setProperty('--story-progress', `${progress}%`);
      }
    }
  }

  let lastUpdateTime = 0;
  const UPDATE_INTERVAL = 100;

  function attachVideoProgressListeners() {
    const videos = pdpUgcStoriesContainerNode.querySelectorAll('video');

    videos.forEach((video, index) => {
      video.addEventListener('timeupdate', () => {
        const currentIndex = pdpUgcStoriesEmblaApi.selectedScrollSnap();

        if (index === currentIndex) {
          const now = Date.now();

          if (now - lastUpdateTime < UPDATE_INTERVAL) {
            return;
          }
          lastUpdateTime = now;

          const storyBars = document.querySelectorAll('.pdp-ugc-stories .story-bar');
          const currentBar = storyBars[currentIndex];

          if (video && video.duration && currentBar) {
            const progress = (video.currentTime / video.duration) * 100;
            currentBar.style.setProperty('--story-progress', `${progress}%`);
          }
        }
      });

      video.addEventListener('ended', () => {
        const currentIndex = pdpUgcStoriesEmblaApi.selectedScrollSnap();

        if (index === currentIndex) {
          const storyBars = document.querySelectorAll('.pdp-ugc-stories .story-bar');
          storyBars[currentIndex].style.setProperty('--story-progress', `100%`);

          if (pdpUgcStoriesEmblaApi.canScrollNext()) {
            setTimeout(() => {
              pdpUgcStoriesEmblaApi.scrollNext();
              // 'select' event will handle reset + play
            }, 300);
          }
        }
      });
    });
  }

  function resetVideos() {
    const videos = pdpUgcStoriesContainerNode.querySelectorAll('video');
    videos.forEach(video => {
      video.currentTime = 0;
      video.pause();
    });
    const playButton = document.querySelector('.pdp-ugc-stories__button--play');
    if (playButton) {
      playButton.dataset.videoPlaying = 'true';
    }
  }

  pdpUgcStoriesSlideButtons.forEach((slideButton) => {
    const index = Number(slideButton.dataset.slideIndex);
    slideButton.addEventListener('click', () => {
      resetVideos();
      pdpUgcStoriesEmblaApi.scrollTo(index);
      updateProgress();
      const currentSlideVideo = pdpUgcStoriesContainerNode.querySelector(
        `.pdp-ugc-stories__slide[data-slide-index="${index}"] video`
      );
      if (currentSlideVideo) {
        currentSlideVideo.currentTime = 0;
        currentSlideVideo.play();
      }
    });
  });

  function updateArrows() {
    const prevBtn = document.querySelector('.pdp-ugc-stories__button--prev');
    const nextBtn = document.querySelector('.pdp-ugc-stories__button--next');

    if (pdpUgcStoriesEmblaApi.canScrollPrev()) {
      prevBtn.classList.remove("m-button--disabled");
    } else {
      prevBtn.classList.add("m-button--disabled");
    }
    if (pdpUgcStoriesEmblaApi.canScrollNext()) {
      nextBtn.classList.remove("m-button--disabled");
    } else {
      nextBtn.classList.add("m-button--disabled");
    }
  }

  updateArrows();
  updateProgress();
  attachVideoProgressListeners();

  pdpUgcStoriesEmblaApi.on('select', function () {
    updateArrows();
    updateProgress();

    const currentIndex = pdpUgcStoriesEmblaApi.selectedScrollSnap();
    resetVideos();
    const currentSlideVideo = pdpUgcStoriesContainerNode.querySelector(
      `.pdp-ugc-stories__slide[data-slide-index="${currentIndex}"] video`
    );
    if (currentSlideVideo) {
      currentSlideVideo.currentTime = 0;
      currentSlideVideo.play();
    }
  });

  pdpUgcStoriesEmblaApi.on('reInit', function () {
    updateArrows();
    updateProgress();
  });

  const pdpUgcStoriesSoundButton = document.querySelector('.pdp-ugc-stories__button--sound');

  pdpUgcStoriesSoundButton?.addEventListener('click', () => {
    const soundOn = pdpUgcStoriesSoundButton.dataset.soundOn;
    const videos = pdpUgcStoriesContainerNode.querySelectorAll('video');
    pdpUgcStoriesSoundButton.dataset.soundOn = soundOn === 'false' ? 'true' : 'false';

    if (soundOn === 'false') {
      videos.forEach(video => {
        video.muted = false;
      });
    } else {
      videos.forEach(video => {
        video.muted = true;
      });
    }
  });

  const pdpUgcStoriesPlayButton = document.querySelector('.pdp-ugc-stories__button--play');

  pdpUgcStoriesPlayButton?.addEventListener('click', () => {
    const currentVideoIndex = pdpUgcStoriesEmblaApi.selectedScrollSnap();
    const currentSlideVideo = pdpUgcStoriesContainerNode.querySelector(
      `.pdp-ugc-stories__slide[data-slide-index="${currentVideoIndex}"] video`
    );

    if (currentSlideVideo.paused) {
      currentSlideVideo.play();
      pdpUgcStoriesPlayButton.dataset.videoPlaying = 'true';
    } else {
      currentSlideVideo.pause();
      pdpUgcStoriesPlayButton.dataset.videoPlaying = 'false';
    }
  });

});